<template>
    <table>
        <thead>
        <tr>
            <th></th>
            <th>{{ uLang('app.backoffice') }}</th>
            <th>{{ uLang('app.trajectory_manager') }}</th>
            <th>{{ uLang('app.candidate') }}</th>
            <th>{{ uLang('app.employer') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td>{{ uLang('app.who_can_see') }}</td>
            <td> <!-- Backoffice -->
                <i :class="{'fa fa-check green': canSee('backoffice'), 'fa fa-times red': !canSee('backoffice') }"></i>
            </td>
            <td> <!-- Trajectmanager -->
                <i :class="{'fa fa-check green': canSee('trajectory_manager'), 'fa fa-times red': !canSee('trajectory_manager') }"></i>
            </td>
            <td> <!-- Kandidaat -->
                <i :class="{'fa fa-check green': canSee('candidate'), 'fa fa-times red': !canSee('candidate') }"></i>
            </td>
            <td> <!-- Opdrachtgever -->
                <i :class="{'fa fa-check green': canSee('employer'), 'fa fa-times red': !canSee('employer') }"></i>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "log-permission-table",
    props: {
        log: {
            required: true
        }
    },
    methods: {
        canSee(type) {
            return !!+JSON.parse(this.log.who_can_see)[type]
        }
    }
}
</script>

<style scoped>
.green {
    color: green;
}

.red {
    color: red;
}
</style>
